import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import React from "react";
import css from "./Heading.module.scss";

type Level = 1 | 2 | 3 | 4;

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: Level;
  display?: Level;
  /**
   * Merges its props onto its immediate child.
   * @link https://www.radix-ui.com/primitives/docs/utilities/slot#usage
   */
  asChild?: boolean;
}

export function Heading({ level = 1, display = level, className, asChild, ...props }: HeadingProps) {
  const Element = asChild ? Slot : `h${level}`;

  return <Element className={clsx(css.heading, className)} {...props} data-display={display} />;
}
